import uuid from 'uuid/v4';

export default class Estimate {
  constructor(estimateName = 'Estimate 1') {
    this.designId = uuid();
    this.containers = [];
    this.name = estimateName;
    this.retail = 0.0;
    this.isLinked = false;
  }

  addContainer(container) {
    this.containers.push(container.containerId);
    container.designId = this.designId; // eslint-disable-line no-param-reassign
  }
}
